module.exports = __webpack_public_path__ + "static/media/default-image-profile.5cee497f.svg";